export default {
  home: 'Hjem',
  menu: 'Menu',
  orders: 'Ordrer',
};
